import { AxiosResponse } from "axios";
import axios from "../../../lib/axios";
import { API_ENDPOINTS } from "../../../constants/api_endpoints";
import { TResponse } from "../../../types/common";
import { INotificationPreferences } from "../../../types/api/integrations";

export async function getNotificationPreferences(): Promise<
  AxiosResponse<TResponse<INotificationPreferences>>
> {
  return axios.get<TResponse<INotificationPreferences>>(
    API_ENDPOINTS.NOTIFICATION_PREFERENCES
  );
}

export async function updateNotificationPreferences(
  data: INotificationPreferences
): Promise<AxiosResponse<TResponse<INotificationPreferences>>> {
  return axios.put<TResponse<INotificationPreferences>>(
    API_ENDPOINTS.NOTIFICATION_PREFERENCES,
    data
  );
}
